var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Flex, Icon, Text, VBadge } from 'shared/components/ui';
import { getHighestRisk, riskLevelRender } from 'constants/riskLevel';
import { RiskTooltip } from '../RiskTooltip';
import { FlaggedContent } from 'src/flagging/components';
var RiskTableCell = function (_a) {
    var riskToSelf = _a.riskToSelf, riskToOthers = _a.riskToOthers, children = _a.children;
    var highestRisk = getHighestRisk(riskToOthers, riskToSelf);
    // riskLevelRender displays
    var risk = highestRisk ? riskLevelRender[highestRisk] : null;
    return (_jsxs(_Fragment, { children: [_jsx(RiskTooltip, __assign({ riskToOthers: riskToOthers, riskToSelf: riskToSelf, isDisabled: !risk }, { children: _jsx(Box, __assign({ width: 'fit-content' }, { children: _jsx(FlaggedContent, __assign({ flag: 'ENABLE_MEASURES_MBC_UPDATES', disabledContent: _jsxs(Flex, __assign({ alignItems: 'center', width: "fit-content" }, { children: [risk && risk.icon && (_jsx(Icon, { as: risk.icon, color: risk.color, fontSize: "xl", fontWeight: 'bold', boxSize: '2rem', pr: 2 })), risk ? (_jsx(Text, __assign({ size: "body2", color: risk.color }, { children: risk.label }))) : (_jsx(Text, __assign({ color: "gray.500" }, { children: "No risk data" })))] })) }, { children: _jsx(Flex, __assign({ alignItems: 'center', width: "fit-content" }, { children: risk ? (_jsx(VBadge, __assign({ colorScheme: risk.colorScheme, variant: risk.emphasis }, { children: risk.label }))) : (_jsx(Text, __assign({ color: "gray.500" }, { children: "No risk data" }))) })) })) })) })), children] }));
};
export { RiskTableCell };
